export function isValidCraneHost(craneHost) {
  const validHosts = [
    'immersive.macmillanhighered.com',
    'immersive.macmillanlearning.com',
    'immersive.macmillantech.com',
    'immersive.mldev.cloud',
    'immersive.achv-lt-nonprod.mml.cloud',
    'immersive.macmillan.cloud',
    'immersive-qa.achv-lt-nonprod.mml.cloud',
    'immersive-qa.macmillanhighered.com',
    'immersive-qa.macmillanlearning.com',
    'immersive-qa.macmillantech.com',
    'immersive-qa.mldev.cloud',
    'immersive-qa.macmillan.cloud'
  ];

  return validHosts.indexOf(craneHost) > -1;
}

async function loadCraneScript({ useQADomain = false }) {
  try {
    return await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = useQADomain ?
        "https://immersive-qa.macmillan.cloud/reader/external.js?v=" + Date.now() :
        "https://immersive.macmillan.cloud/crane.js?v=" + Date.now();
      script.async = true;
      script.addEventListener('load', () => resolve(true));
      script.addEventListener('error', () => reject(new Error(`error event on loadCraneScript script load`)));
      document.body.appendChild(script);
    });
  } catch (err) {
    console.error(`parseUrlQuery -- loadCraneScript -- failed to load script`, err);
    window.logger.error('parseUrlQuery -- loadCraneScript -- failed to load script', { err });
    return false;
  }
}

function loadCraneHost({ craneRootDomain, useQADomain = false }) {
  // LST-987: Ensure crane is loaded with the same root domain to prevent session and cookie errors
  const eReaderRootDomain = window.location.host.split('.').slice(-2).join('.').split(':')[0];
  const craneHost = useQADomain ? `immersive-qa.${craneRootDomain}` : `immersive.${craneRootDomain}`;

  if (!isValidCraneHost(craneHost) || craneRootDomain !== eReaderRootDomain) {
    window.logger.error('parseUrlQuery -- loadCraneHost -- invalid host', {
      eReaderRootDomain,
      craneHost: craneHost
    });
  }

  window.Crane.setHost(craneHost);
}

function checkMobile(innerWidth) {
  const mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
  const tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i

  const userAgent = navigator.userAgent;
  const isPhone = mobileRE.test(userAgent) || innerWidth <= 480;
  const isTablet = tabletRE.test(userAgent) || innerWidth <= 768;
  const isMobile = isTablet || isPhone;

  const mobileProps = {
    isMobile,
    isPhone,
    isTablet
  };

  return mobileProps;
}

function setLoggingParams(query) {
  window._ref_id = query.data.rid;
  window._req_id = query.data.req_id;
}

async function parseUrlQuery() {
  const mobileProps = checkMobile(window.innerWidth);
  let query = {
    isMobile: mobileProps.isMobile,
    isTablet: mobileProps.isTablet,
    isPhone: mobileProps.isPhone,
    data: {}
  };
  let queryParams;
  let params;

  const vbid = window.location.pathname;
  if (vbid === '/') {
    queryParams = window.location.search.split('?').slice(1).join('&').split('&');
  } else {
    queryParams = window.location.search.split('?')[1].split('&');
    queryParams.push(`vbid=${vbid.slice(1)}`);
  }

  for (params of queryParams) {
    const keyValue = params.split('=');
    const key = keyValue[0].replace('custom_', '');

    query.data[key] = keyValue[1];
  }

  const craneRootDomain = query.data.ro;

  setLoggingParams(query);

  const useQADomain = query.data.irqa === "true";

  await loadCraneScript({ useQADomain });
  loadCraneHost({ craneRootDomain, useQADomain });

  return query;
}


export default parseUrlQuery;
